export default "__VITE_ASSET__Ile7nGEF__"